import { defineStore } from 'pinia'
import { Stats, DailyStats, User, Product, Order, COA, PromoCode, ShippingFee } from '../types'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    isMobile: false,
    isTablet: false,
    isSidebarMinimized: false,
    statsInfo: {} as Stats,
    dailyStatsList: [] as DailyStats[],
    userList: [] as User[],
    productList: [] as Product[],
    promoCodeList: [] as PromoCode[],
    shippingFeeList: [] as ShippingFee[],
    orderList: [] as Order[],
    coaList: [] as COA[],
  }) as {
    isMobile: boolean
    isTablet: boolean
    isSidebarMinimized: boolean
    userCount: number
    productCount: number
    orderCount: number
    totalEarning: number
    statsInfo: Stats
    dailyStatsList: DailyStats[]
    userList: User[]
    productList: Product[]
    promoCodeList: PromoCode[]
    shippingFeeList: ShippingFee[]
    orderList: Order[]
    coaList: COA[]
  },
})
